const createHeaders = () => ({
  authorization: `Bearer ${localStorage.getItem("token")}`,
});

export { createHeaders };
